import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "image-placeholder",
  "use": "image-placeholder-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"image-placeholder\"><path d=\"M2.75 18.75h14a2 2 0 002-2v-14a2 2 0 00-2-2h-14a2 2 0 00-2 2v14a2 2 0 002 2zm0 0l11-11 5 5m-11-6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/image-placeholder.svg
// module id = aSVe
// module chunks = 39 44